// src/components/PaymentModal.jsx
// MODIFIÉ : Phase 2 - Gestion timeout polling + Écran de récupération paiement ambigu

import React, { useState, useEffect } from 'react';
import './payment-modal.css';
import ApiService from '../services/ApiService';
import { useAuth } from '../contexts/AuthContext';

// Fonction pour formater les prix
const formatPrice = (price) => {
  return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
};

// ✅ NOUVEAU (Phase 2) : Numéro WhatsApp support
const SUPPORT_WHATSAPP = '686127882';

const PaymentModal = ({ isOpen, onClose, orderData, onPaymentSuccess }) => {
  const { user } = useAuth();
  
  const [paymentMethod, setPaymentMethod]   = useState('');
  const [phoneNumber, setPhoneNumber]       = useState('');
  const [isLoading, setIsLoading]           = useState(false);
  const [error, setError]                   = useState('');
  const [paymentStep, setPaymentStep]       = useState('selection'); // selection | input | processing | ambiguous
  const [statusMessage, setStatusMessage]   = useState('');
  const [sessionData, setSessionData]       = useState(null);
  const [isInitializing, setIsInitializing] = useState(false);
  const [preorderId, setPreorderId]         = useState(null);
  // ✅ NOUVEAU (Phase 2) : Stocker le payToken courant pour la récupération
  const [currentPayToken, setCurrentPayToken] = useState(null);
  // ✅ NOUVEAU (Phase 2) : État de la vérification de récupération
  const [isRecovering, setIsRecovering]     = useState(false);
  const [recoveryError, setRecoveryError]   = useState('');

  // Réinitialiser l'état quand le modal se ferme
  useEffect(() => {
    if (!isOpen) {
      setPaymentMethod('');
      setPhoneNumber('');
      setError('');
      setPaymentStep('selection');
      setStatusMessage('');
      setSessionData(null);
      setIsInitializing(false);
      setPreorderId(null);
      setCurrentPayToken(null); // ✅ NOUVEAU
      setIsRecovering(false);   // ✅ NOUVEAU
      setRecoveryError('');     // ✅ NOUVEAU
    } else if (isOpen && orderData) {
      if (orderData.payment_method) {
        setPaymentMethod(orderData.payment_method);
        if (orderData.payment_method === 'MoMo') {
          setPaymentStep('input');
          setIsInitializing(false);
        } else {
          initializePaymentOnOpen();
        }
      }
    }
  }, [isOpen, orderData]);
  
  // Vérifier que l'utilisateur est connecté
  useEffect(() => {
    if (isOpen && (!user || !user.id)) {
      // console.error("❌ PaymentModal : Utilisateur non connecté ou id_utilisateur manquant");
      setError("Vous devez être connecté pour effectuer un paiement");
      setPaymentStep('selection');
    } else if (isOpen && user) {
      // console.log("✅ PaymentModal : Utilisateur connecté", {
        // id: user.id,
        // nom: user.nom,
        // prenom: user.prenom,
        // telephone: user.telephone
      // });
    }
  }, [isOpen, user]);

  // Initialisation Orange Money
  const initializePaymentOnOpen = async () => {
    if (!user || !user.id) {
      setError("Vous devez être connecté pour effectuer un paiement");
      setPaymentStep('selection');
      setIsInitializing(false);
      return;
    }
    
    setIsInitializing(true);
    setError('');
    setStatusMessage('Initialisation du paiement...');

    try {
      // console.log("🚀 Initialisation paiement Orange Money", {
        // id_utilisateur: user.id,
        // id_distributeur: orderData.id_distributeur,
        // montant: orderData.montant_total
      // });
      
      const initResponse = await fetch(`${ApiService.getBaseUrl()}${ApiService.getPaymentEndpoints('OM').initiate}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        },
        body: JSON.stringify({
          id_utilisateur:  user.id,
          id_distributeur: orderData.id_distributeur,
          amount:          orderData.montant_total,
          consigne_casiers: orderData.consigne_casiers || 0,
          data_panier:     orderData.data_panier || null,
          data_livraison:  orderData.data_livraison || null,
          mode_paiement:   'OM'
        })
      });

      const initData = await initResponse.json();
      
      // console.log("📥 Réponse initialisation:", initData);

      if (!initData.success) {
        throw new Error(initData.message || 'Échec de l\'initialisation du paiement');
      }

      setSessionData(initData.data);
      setPaymentStep('input');
      setStatusMessage('');
      
      if (initData.data?.preorder_id) {
        setPreorderId(initData.data.preorder_id);
        // console.log("📝 Précommande créée avec ID:", initData.data.preorder_id);
      }

      // ✅ NOUVEAU (Phase 2) : Stocker le payToken dès l'initialisation
      if (initData.data?.pay_token) {
        setCurrentPayToken(initData.data.pay_token);
      }
      
      
    } catch (err) {
      // console.error('❌ Erreur lors de l\'initialisation:', err);
      setError(`Erreur d'initialisation: ${err.message}`);
      setPaymentStep('selection');
    } finally {
      setIsInitializing(false);
    }
  };

  const handlePaymentMethodSelect = (method) => {
    setPaymentMethod(method);
    setError('');
    if (method === 'MoMo') {
      setPaymentStep('input');
    } else {
      initializePaymentOnOpen();
    }
  };

  const validatePhoneNumber = (number) => {
    const cleanNumber = number.replace(/\s/g, '');
    const regex = /^(6[5-9]\d{7}|2[0-9]\d{7})$/;
    return regex.test(cleanNumber);
  };

  const formatPhoneNumber = (number) => {
    const clean = number.replace(/\D/g, '');
    if (clean.length >= 3) {
      return clean.slice(0, 3) + ' ' + clean.slice(3, 6) + ' ' + clean.slice(6, 9);
    }
    return clean;
  };

  const handlePhoneNumberChange = (e) => {
    const value = e.target.value.replace(/\D/g, '');
    if (value.length <= 9) {
      setPhoneNumber(value);
      setError('');
    }
  };

  // === LOGIQUE DE PAIEMENT PRINCIPALE ===
  const executePayment = async () => {
    if (!validatePhoneNumber(phoneNumber)) {
      setError('Numéro de téléphone invalide');
      return;
    }
    
    if (!user || !user.id) {
      setError("Session expirée. Veuillez vous reconnecter.");
      return;
    }

    setIsLoading(true);
    setError('');
    setPaymentStep('processing');
    setStatusMessage('Envoi de la demande de paiement...');

    try {
      let response;
      let data;

      if (paymentMethod === 'OM') {
        if (!sessionData || !sessionData.pay_token) {
          throw new Error('Session de paiement invalide. Veuillez réessayer.');
        }

        // console.log("💳 Exécution paiement Orange Money", {
          // subscriber_msisdn: phoneNumber,
          // session_id: sessionData.session_id
        // });

        response = await fetch(`${ApiService.getBaseUrl()}${ApiService.getPaymentEndpoints('OM').execute}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('authToken')}`
          },
          body: JSON.stringify({
            subscriber_msisdn: phoneNumber,
            session_id:        sessionData.session_id
          })
        });
        data = await response.json();

        if (!data.success) {
          const msg = data.data?.inittxnmessage || data.message || 'Paiement échoué';
          throw new Error(msg);
        }

        setStatusMessage('En attente de confirmation...\nVeuillez valider le paiement sur votre téléphone');
        // ✅ S'assurer que currentPayToken est bien défini avant le polling
        const payTokenForPolling = currentPayToken || sessionData.pay_token;
        setCurrentPayToken(payTokenForPolling);
        checkOrangeStatus(payTokenForPolling);

      } else if (paymentMethod === 'MoMo') {
        // console.log("💳 Exécution paiement MTN Mobile Money", {
          // phone:           phoneNumber,
          // amount:          orderData.montant_total,
          // order_id:        orderData.id_commande,
          // id_distributeur: orderData.id_distributeur
        // });
        
        response = await fetch(`${ApiService.getBaseUrl()}${ApiService.getPaymentEndpoints('MoMo').execute}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('authToken')}`
          },
          body: JSON.stringify({
            phone:            phoneNumber,
            amount:           orderData.montant_total,
            order_id:         orderData.id_commande,
            id_distributeur:  orderData.id_distributeur,
            consigne_casiers: orderData.consigne_casiers || 0,
            id_utilisateur:   user.id,
            data_panier:      orderData.data_panier || null,
            data_livraison:   orderData.data_livraison || null,
            mode_paiement:    'MoMo'
          })
        });
        data = await response.json();

        if (!data.success) {
          throw new Error(data.message || 'Échec de l\'initialisation MTN');
        }

        if (data.preorder_id) {
          setPreorderId(data.preorder_id);
          // console.log("📝 Précommande MTN créée avec ID:", data.preorder_id);
        }

        setStatusMessage('En attente de confirmation...\nVeuillez valider le paiement sur votre téléphone');
        checkMTNStatus(data.reference_id);
      }

    } catch (err) {
      // console.error('❌ Erreur paiement:', err);
      setError(err.message);
      setIsLoading(false);
      setPaymentStep('input');
    }
  };

  // === POLLING ORANGE MONEY ===
  const checkOrangeStatus = async (payToken, attempts = 0) => {
    const maxAttempts = 60; // 60 × 2s = 2 minutes

    // ✅ MODIFIÉ (Phase 2) : Au lieu d'afficher une erreur "réessayez",
    // basculer vers l'écran de récupération ambiguë
    if (attempts >= maxAttempts) {
      // console.warn("⏱️ Polling timeout après 2 minutes - passage en mode récupération");
      setIsLoading(false);
      setPaymentStep('ambiguous');
      setRecoveryError('');
      return;
    }

    try {
      const controller = new AbortController();
      const timeoutId  = setTimeout(() => controller.abort(), 10000);

      const response = await fetch(`${ApiService.getBaseUrl()}${ApiService.getPaymentEndpoints('OM').status}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        },
        body: JSON.stringify({ pay_token: payToken }),
        signal: controller.signal
      });

      clearTimeout(timeoutId);
      const data = await response.json();

      if (data.success && data.data) {
        // console.log(`📊 Statut paiement Orange (tentative ${attempts + 1}):`, data.data.status);
        
        if (data.data.status === 'SUCCESSFULL') {
          // console.log("✅ Paiement Orange réussi !");
          handlePaymentSuccess('OM', payToken, null);
          return;
        } else if (data.data.status === 'FAILED') {
          // console.error("❌ Paiement Orange échoué");
          setError('Paiement échoué. Veuillez réessayer.');
          setIsLoading(false);
          setPaymentStep('input');
          return;
        }
        // PENDING ou autre → continuer le polling
      }
      // En cas de data.success === false (ex : session expirée côté PHP),
      // on continue quand même le polling car le backend va régénérer le token.

      setTimeout(() => checkOrangeStatus(payToken, attempts + 1), 2000);

    } catch (err) {
      // console.warn("⚠️ Erreur vérification statut, nouvelle tentative...", err.message);
      setTimeout(() => checkOrangeStatus(payToken, attempts + 1), 2000);
    }
  };

  // === POLLING MTN MOBILE MONEY ===
  const checkMTNStatus = async (referenceId, attempts = 0) => {
    const maxAttempts = 60;

    if (attempts >= maxAttempts) {
      // MTN : timeout → écran ambiguous également
      // console.warn("⏱️ Polling MTN timeout - passage en mode récupération");
      setIsLoading(false);
      setPaymentStep('ambiguous');
      setRecoveryError('');
      return;
    }

    try {
      const controller = new AbortController();
      const timeoutId  = setTimeout(() => controller.abort(), 10000);

      const response = await fetch(`${ApiService.getBaseUrl()}${ApiService.getPaymentEndpoints('MoMo').status}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        },
        body: JSON.stringify({ reference_id: referenceId }),
        signal: controller.signal
      });

      clearTimeout(timeoutId);
      const data = await response.json();

      if (data.success) {
        // console.log(`📊 Statut paiement MTN (tentative ${attempts + 1}):`, data.status);

        if (data.status === 'SUCCESSFUL') {
          // console.log("✅ Paiement MTN réussi !");
          handlePaymentSuccess('MTN', null, referenceId);
          return;
        } else if (data.status === 'FAILED') {
          // console.error("❌ Paiement MTN échoué");
          setError('Paiement échoué. Veuillez réessayer.');
          setIsLoading(false);
          setPaymentStep('input');
          return;
        }
      }

      setTimeout(() => checkMTNStatus(referenceId, attempts + 1), 2000);

    } catch (err) {
      // console.warn("⚠️ Erreur vérification statut MTN, nouvelle tentative...", err.message);
      setTimeout(() => checkMTNStatus(referenceId, attempts + 1), 2000);
    }
  };

  // ✅ NOUVEAU (Phase 2) : Vérification manuelle après timeout de polling
  const recoverPayment = async () => {
    const payToken = currentPayToken || sessionData?.pay_token;

    if (!payToken) {
      setRecoveryError("Référence de paiement introuvable. Contactez le support.");
      return;
    }

    setIsRecovering(true);
    setRecoveryError('');

    try {
      const response = await fetch(`${ApiService.getBaseUrl()}${ApiService.getPaymentEndpoints(paymentMethod).recover}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        },
        body: JSON.stringify({ pay_token: payToken })
      });

      const data = await response.json();
      // console.log("📥 Réponse récupération:", data);

      if (!data.success) {
        setRecoveryError(data.message || "Impossible de vérifier votre paiement. Contactez le support.");
        return;
      }

      if (data.status === 'SUCCESSFULL') {
        // Paiement confirmé → déclencher le flux normal de création de commande
        // console.log("✅ Récupération réussie - paiement confirmé !");
        handlePaymentSuccess('OM', payToken, null);

      } else if (data.status === 'PENDING') {
        setRecoveryError("Votre paiement est toujours en cours de traitement chez Orange Money. Réessayez dans 2 minutes ou contactez le support.");

      } else if (data.status === 'FAILED') {
        // Paiement définitivement échoué → retour à l'écran de saisie
        setError('Votre paiement a échoué. Vous pouvez réessayer sans risque.');
        setPaymentStep('input');

      } else {
        setRecoveryError("Statut de paiement inconnu. Contactez le support avec votre référence.");
      }

    } catch (err) {
      // console.error("❌ Erreur récupération paiement:", err);
      setRecoveryError("Erreur réseau lors de la vérification. Vérifiez votre connexion et réessayez.");
    } finally {
      setIsRecovering(false);
    }
  };

  // ✅ NOUVEAU (Phase 2) : Ouvrir WhatsApp avec message pré-rempli
  const openWhatsAppSupport = () => {
    const payToken  = currentPayToken || sessionData?.pay_token || 'inconnu';
    const montant   = orderData?.montant_total ? formatPrice(orderData.montant_total) + ' F' : 'montant inconnu';
    const message   = `Bonjour, j'ai un problème avec mon paiement BCCV.\n\nRéférence : ${payToken}\nMontant : ${montant}\n\nMerci de m'aider.`;
    const url       = `https://wa.me/${SUPPORT_WHATSAPP}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
  };

  // === GESTION DU SUCCÈS DU PAIEMENT (inchangé)
  const handlePaymentSuccess = (operator, payToken, referenceId) => {
    setStatusMessage('Paiement réussi !');
    
    setTimeout(() => {
      onPaymentSuccess({
        success:      true,
        operator,
        pay_token:    payToken,
        reference_id: referenceId,
        amount:       orderData.montant_total,
        phone:        phoneNumber,
        preorder_id:  preorderId
      });
      onClose();
    }, 1500);
  };

  // Calculer si on a une consigne
  const hasConsigne      = orderData?.consigne_casiers && orderData.consigne_casiers > 0;
  const montantProduits  = orderData?.montant_produits || (orderData?.montant_total - (orderData?.consigne_casiers || 0));

  if (!isOpen) return null;

  return (
    <div
      className="payment-modal-overlay"
      onClick={(e) => {
        // Fermeture désactivée pendant le processing et pendant la récupération
        if (e.target === e.currentTarget && !isLoading && !isInitializing && paymentStep !== 'ambiguous') {
          onClose();
        }
      }}
    >
      <div className="payment-modal" onClick={(e) => e.stopPropagation()}>
        <div className="payment-modal-header">
          <h2>Paiement de la commande</h2>
          {/* Masquer le bouton fermer pendant le processing et l'ambiguïté */}
          {!isLoading && !isInitializing && paymentStep !== 'processing' && paymentStep !== 'ambiguous' && (
            <button className="close-button" onClick={onClose}>×</button>
          )}
        </div>

        <div className="payment-modal-content">
          {/* Récapitulatif */}
          <div className="order-summary">
            <h3>Récapitulatif</h3>
            
            {hasConsigne ? (
              <>
                <div className="summary-line summary-products">
                  <span>Produits</span>
                  <span>{formatPrice(montantProduits)} F</span>
                </div>
                <div className="summary-line summary-consigne">
                  <span>
                    Consigne casiers ({orderData.nb_casiers_consignes || 0})
                    <span className="consigne-hint">remboursable</span>
                  </span>
                  <span>{formatPrice(orderData.consigne_casiers)} F</span>
                </div>
                <div className="summary-line summary-total">
                  <span>Total à payer</span>
                  <span className="amount">{formatPrice(orderData.montant_total)} F</span>
                </div>
              </>
            ) : (
              <div className="summary-line">
                <span>Commande #{orderData?.id_commande}</span>
                <span className="amount">{formatPrice(orderData?.montant_total)} F</span>
              </div>
            )}
          </div>

          {/* Sélection du mode */}
          {paymentStep === 'selection' && !isInitializing && (
            <div className="payment-methods">
              <h3>Choisissez votre mode de paiement</h3>

              <button
                className="payment-method-button orange-money"
                onClick={() => handlePaymentMethodSelect('OM')}
                disabled={!user || !user.id}
              >
                <img src="/images/payment/orange-money-logo.png" alt="Orange Money" />
                <span>Orange Money</span>
              </button>

              <button
                className="payment-method-button mtn-momo"
                onClick={() => handlePaymentMethodSelect('MoMo')}
                disabled={!user || !user.id}
              >
                <img src="/images/payment/mtn-momo-logo.png" alt="MTN Mobile Money" />
                <span>MTN Mobile Money</span>
              </button>
            </div>
          )}

          {/* Initialisation */}
          {isInitializing && (
            <div className="payment-processing">
              <div className="spinner"></div>
              <p className="status-message">Préparation du paiement...</p>
            </div>
          )}

          {/* Saisie du numéro */}
          {paymentStep === 'input' && !isInitializing && (
            <div className="phone-input-section">
              <button
                className="back-button"
                onClick={() => {
                  setPaymentStep('selection');
                  setSessionData(null);
                  setCurrentPayToken(null);
                  setError('');
                  setPreorderId(null);
                }}
              >
                ← Retour
              </button>

              <div className="payment-method-selected">
                <img
                  src={
                    paymentMethod === 'OM'
                      ? '/images/payment/orange-money-logo.png'
                      : '/images/payment/mtn-momo-logo.png'
                  }
                  alt={paymentMethod}
                  className="selected-logo"
                />
                <p className="payment-instruction">
                  Saisissez votre numéro pour payer avec{' '}
                  <strong>{paymentMethod === 'OM' ? 'Orange Money' : 'MTN Mobile Money'}</strong>
                </p>
              </div>

              <div className="phone-input-container">
                <label htmlFor="phone">Numéro de téléphone</label>
                <input
                  type="tel"
                  id="phone"
                  value={formatPhoneNumber(phoneNumber)}
                  onChange={handlePhoneNumberChange}
                  placeholder="6XX XXX XXX"
                  maxLength="11"
                  autoFocus
                />
                {error && (
                  <div className="error-with-action">
                    <p className="error-message">{error}</p>
                    {error.includes('solde') && (
                      <button className="retry-button" onClick={executePayment}>
                        Réessayer
                      </button>
                    )}
                  </div>
                )}
              </div>

              <button
                className="pay-button"
                onClick={executePayment}
                disabled={phoneNumber.length !== 9}
              >
                Payer {formatPrice(orderData?.montant_total)} F
              </button>
            </div>
          )}

          {/* Traitement en cours */}
          {paymentStep === 'processing' && (
            <div className="payment-processing">
              <div className="spinner"></div>
              <p className="status-message">{statusMessage}</p>
              {statusMessage.includes('valider') && (
                <>
                  <div className="phone-display">
                    <span className="phone-icon">📱</span>
                    <span>{formatPhoneNumber(phoneNumber)}</span>
                  </div>
                  <p className="ussd-hint">
                    Une demande de paiement a été envoyée sur votre téléphone.
                    Veuillez confirmer pour finaliser.
                  </p>
                </>
              )}
            </div>
          )}

          {/* ✅ NOUVEAU (Phase 2) : Écran paiement ambigu — après timeout de polling */}
          {paymentStep === 'ambiguous' && (
            <div className="payment-ambiguous">
              
              <div className="ambiguous-icon">⚠️</div>
              
              <h3 className="ambiguous-title">Vérification en cours</h3>
              
              <p className="ambiguous-message">
                La confirmation de votre paiement a pris trop de temps.
                <strong> Ne payez pas à nouveau</strong> si vous avez déjà été débité.
              </p>

              {/* Référence technique pour le support */}
              {(currentPayToken || sessionData?.pay_token) && (
                <div className="ambiguous-reference">
                  <span className="reference-label">Référence :</span>
                  <code className="reference-value">
                    {currentPayToken || sessionData?.pay_token}
                  </code>
                </div>
              )}

              {/* Message d'erreur de récupération */}
              {recoveryError && (
                <div className="ambiguous-recovery-error">
                  <p>{recoveryError}</p>
                </div>
              )}

              {/* Bouton principal : vérifier le paiement */}
              <button
                className="ambiguous-btn-primary"
                onClick={recoverPayment}
                disabled={isRecovering}
              >
                {isRecovering ? (
                  <>
                    <div className="spinner-small"></div>
                    Vérification en cours...
                  </>
                ) : (
                  <>
                    ✅ Vérifier mon paiement
                  </>
                )}
              </button>

              {/* Bouton secondaire : contacter le support WhatsApp */}
              <button
                className="ambiguous-btn-whatsapp"
                onClick={openWhatsAppSupport}
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                </svg>
                Contacter le support
              </button>

              <p className="ambiguous-hint">
                Notre équipe est disponible pour résoudre votre problème rapidement.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PaymentModal;